import {useTranslation} from 'react-i18next';
import {useModalControls} from '@chekin/guestapp-ui-kit';
import QuestionMarkAndText from 'components/common/QuestionMarkAndText';
import {ResponsiveSheet} from '@chekinapp/ui';

type Props = {
  className?: string;
};
export const WhyDataRequired = ({className}: Props) => {
  const {t} = useTranslation();
  const {
    isOpen: isSignatureModal,
    openModal: openSignatureModal,
    closeModal: closeSignatureModal,
  } = useModalControls();

  return (
    <>
      <QuestionMarkAndText
        className={className}
        text={t('why_all_this_data_is_required')}
        onClick={openSignatureModal}
        iconSize={19}
      />
      <ResponsiveSheet
        open={isSignatureModal}
        onClose={closeSignatureModal}
        title={t('why_all_this_data_is_required')}
        closeOnOverlayClick
        contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
        titleClassName="mb-6"
      >
        <div className="px-6 min-[479px]:px-0">
          <span className="mb-[15px] block text-left text-[14px] font-normal leading-6 text-[var(--font-primary)]">
            {t('according_to_the_local_law')}
          </span>
          <span className="mb-[15px] block text-left text-[14px] font-normal leading-6 text-[var(--font-primary)]">
            {t('completing_online_checkin')}
          </span>
          <span className="mb-[15px] block text-left text-[14px] font-normal leading-6 text-[var(--font-primary)]">
            {t('personal_data_handling')}
          </span>
          <a
            href={t('guest_privacy_policy_link')}
            target="_blank"
            rel="noreferrer"
            className="mx-auto mb-5 mt-12 block w-fit text-center text-[16px] font-[var(--large-font-weight)] leading-6 tracking-[-0.15px] text-[var(--text-button-color)] transition-all duration-75 ease-in-out hover:opacity-75 active:opacity-100"
          >
            {t('view_privacy_policy')}
          </a>
        </div>
      </ResponsiveSheet>
    </>
  );
};
